module.exports = __webpack_public_path__ + "img/next.8ee837f8.svg";